import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert('Thank you for contacting us! We will get back to you soon.');
        setFormData({ name: '', email: '', message: '' });
    };

    return (
        <div className="contact-page container">
            <h1 className="contact-title">Contact Us</h1>
            <p className="contact-intro">Email us with any questions or inquiries or use our contact form. We would be happy to answer you as soon as possible.</p>

            <div className="contact-content">
                <div className="locations-section">
                    <div className="location-card">
                        <h2>Urban Bites San Francisco</h2>
                        <p className="address">
                            1825 Irving Street<br />
                            San Francisco, CA 94122
                        </p>
                        <p className="phone">
                            <a href="tel:4155643900">(415) 564-3900</a>
                        </p>
                        <p className="email">
                            <a href="mailto:info@sfhole.com">info@sfhole.com</a>
                        </p>
                    </div>

                    <div className="location-card">
                        <h2>Urban Bites Riverside</h2>
                        <p className="address">
                            1725 Spruce St Suite #101<br />
                            Riverside, CA 92507
                        </p>
                        <p className="phone">
                            <a href="tel:9512154444">(951) 215-4444</a>
                        </p>
                        <p className="email">
                            <a href="mailto:info@sfhole.com">info@sfhole.com</a>
                        </p>
                    </div>
                </div>

                <div className="contact-form-section">
                    <h2>Send us a Message</h2>
                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                rows="5"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            ></textarea>
                        </div>
                        <button type="submit" className="btn-primary">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;
